module.exports = __webpack_public_path__ + "static/media/rab-on.ae4d0eeb.png";